<div class="w-full">
  <table class="detalhe-header mb-4">
    <tr>
      <td><span>006-Registro ANS:</span> {{ dadosPrincipais?.cd_registro_ans }}</td>
      <td><span>003-Competência:</span> {{ dadosPrincipais?.nr_competencia | competencia }}</td>
      <td><span>Cód. lancto:</span> {{ dadosPrincipais?.cd_guia_monitor }}</td>
      <td><span>Lote XTE:</span> {{ dadosPrincipais?.nm_arquivo_envio }}</td>
    </tr>
    <tr>
      <td><span>024-Nr. guia operadora:</span> {{ dadosPrincipais?.nr_guia_operadora }}</td>
      <td><span>023-Nr. guia prestador:</span> {{ dadosPrincipais?.nr_guia_prestador }}</td>
      <td><span>025-Nr. reembolso ou pagto eventual:</span> {{ dadosPrincipais?.nr_reembolso }}</td>
      <td><span>Situação arquivo: </span> {{ dadosPrincipais?.nm_id_situacao_lote }}</td>
    </tr>
  </table>

  <p-tabs [(value)]="activeIndex" (valueChange)="onTabChange($event)">
    <p-tablist>
      <p-tab [value]="0">Dados principais</p-tab>
      <p-tab [value]="1">Dados da internação</p-tab>
      <p-tab [value]="2">Valores e processamento</p-tab>
      <p-tab [value]="3">Itens/Procedimentos da guia</p-tab>
      <p-tab [value]="4">
        <span class="p-tabview-title">
          <span class="round-counter" [ngClass]="{ 'round-counter-empty': !criticasGuia?.length }">{{
            criticasGuia?.length ?? 0
          }}</span>
          Críticas e
          <span class="round-counter" [ngClass]="{ 'round-counter-empty': !motivosRejeicao?.length }">{{
            motivosRejeicao?.length ?? 0
          }}</span>
          Motivos de rejeição
        </span>
      </p-tab>
      <p-tab [value]="5">Movimentação</p-tab>
    </p-tablist>
    <p-tabpanels>
    <p-tabpanel [value]="0">
      <table class="w-full detalhe-content">
        <tbody>
          <tr>
            <td><span>021-Tipo de guia:</span> {{ dadosPrincipais?.nm_tp_guia }}</td>
            <td><span>022-Origem da guia:</span> {{ dadosPrincipais?.nm_id_origem_guia }}</td>
            <td>
              <span>050-Valor informado da guia:</span> {{ dadosPrincipais?.vl_guia_informado | number: '1.2-2' }}
            </td>
          </tr>

          <tr>
            <td><span>Nr. seq. lançamento:</span> {{ dadosPrincipais?.nr_seq_guia }}</td>
            <td><span>Situação na ANS:</span> {{ dadosPrincipais?.nm_st_guia_ans }}</td>
          </tr>
        </tbody>

        <tbody>
          <tr>
            <th colspan="3">
              <span>Prestador executante</span>
              <button
                pButton
                type="button"
                icon="pi pi-list"
                class="p-button p-button-text p-0"
                style="vertical-align: baseline"
                pTooltip="Listar Dados do Prestador"
                (click)="showDetalhePrestadorFor(dadosPrincipais)"
              ></button>
            </th>
          </tr>

          <tr>
            <td><span>013-Tipo docto - CNPJ ou CPF:</span> {{ dadosPrincipais?.nm_id_cnpj_cpf_exec }}</td>
            <td><span>014-CNPJ/CPF executante:</span> {{ dadosPrincipais?.nr_cnpj_cpf_exec | cpfCnpj }}</td>
            <td><span>012-CNES executante:</span> {{ dadosPrincipais?.nr_cnes_exec }}</td>
          </tr>

          <tr>
            <td><span>Tipo de prestador:</span> {{ dadosPrincipais?.nm_tp_prestador }}</td>
            <td><span>Prestador executante:</span> {{ dadosPrincipais?.nm_prestador_exec }}</td>
            <td><span>Prestador CNES:</span> {{ dadosPrincipais?.nm_prestador_cnes }}</td>
          </tr>
          <tr>
            <td>
              <span>010-Padrão do prestador:</span> {{ dadosPrincipais?.id_versao_tiss_exec }} -
              {{ dadosPrincipais?.ds_versao_tiss }}
            </td>
            <td><span>011-Indicador da forma de envio:</span> {{ dadosPrincipais?.nm_id_forma_envio_exec }}</td>
            <td>
              <span>015-Município executante:</span> {{ dadosPrincipais?.cd_municipio_exec }} -
              {{ dadosPrincipais?.municipio_exec }}
            </td>
          </tr>
        </tbody>

        <tbody>
          <tr>
            <th colspan="3"><span>Dados do atendimento</span></th>
          </tr>

          <tr>
            <td><span>045-Tipo de atendimento:</span> {{ dadosPrincipais?.nm_tp_atendimento }}</td>
            <td><span>123-Regime de atendimento:</span> {{ dadosPrincipais?.nm_id_regime_atendimento }}</td>
            <td><span>124-Saúde ocupacional:</span> {{ dadosPrincipais?.nm_id_saude_ocupacional }}</td>
          </tr>

          <tr>
            <td><span>034-Tipo de consulta:</span> {{ dadosPrincipais?.nm_tp_consulta }}</td>
            <td>
              <span>035-CBO do executante:</span> {{ dadosPrincipais?.nr_cbo_exec
              }}{{ dadosPrincipais?.nr_cbo_exec ? ' - ' : '' }}{{ dadosPrincipais?.ds_titulo }}
            </td>
            <td><span>036-Atendimento ao recém-nato:</span> {{ dadosPrincipais?.nm_ib_recem_nato }}</td>
          </tr>
          <tr>
            <td><span>038-Caráter do atendimento:</span> {{ dadosPrincipais?.nm_id_carater_atendimento }}</td>
            <td><span>049-Motivo encerramento:</span> {{ dadosPrincipais?.nm_id_motivo_saida }}</td>
            <td><span>037-Acidente ou doença relacionada?:</span> {{ dadosPrincipais?.nm_id_acidente }}</td>
          </tr>
          <tr>
            <td><span>027-Data solicitação:</span> {{ dadosPrincipais?.dt_solicitacao | date: 'dd/MM/yyyy' }}</td>
            <td><span>028-Data autorização:</span> {{ dadosPrincipais?.dt_autorizacao | date: 'dd/MM/yyyy' }}</td>
            <td><span>029-Data de realização:</span> {{ dadosPrincipais?.dt_realizacao | date: 'dd/MM/yyyy' }}</td>
          </tr>
        </tbody>

        <tbody>
          <tr>
            <th colspan="3">
              <span>Dados do beneficiário</span>
              @if (showDadosBeneficiarioButton) {
                <button
                  pButton
                  type="button"
                  icon="pi pi-list"
                  class="p-button p-button-text p-0"
                  style="vertical-align: baseline"
                  pTooltip="Listar Dados do Beneficiário"
                  (click)="showDadosBeneficiario()"
                ></button>
              }
              @if (!showDadosBeneficiarioButton) {
                <button
                  pButton
                  type="button"
                  icon="pi pi-list"
                  class="p-button p-button-text p-0 button-disabled"
                  style="vertical-align: baseline; color: gray"
                  pTooltip="Recurso acessível somente em módulos avançados"
                ></button>
              }
              @if (pseudonimizarActionVisible) {
                <button
                  pButton
                  type="button"
                  class="p-button p-button-text p-0"
                  style="vertical-align: baseline; width: 1rem"
                  [icon]="'pi ' + (pseudonimizarAction ? 'pi-eye-slash' : 'pi-eye')"
                  (click)="togglePseudonimizar()"
                  [pTooltip]="(pseudonimizarAction ? 'Desativar' : 'Ativar') + ' Pseudonimização'"
                ></button>
              }
            </th>
          </tr>

          <tr>
            <td><span>016-CNS - Cartão nacional de saúde:</span> {{ dadosPrincipais?.nr_cns }}</td>
            <td><span>121-CPF do beneficiário:</span> {{ dadosPrincipais?.nr_cpf_beneficiario }}</td>
            <td>
              <span>020-Nr. plano na ANS:</span> {{ dadosPrincipais?.nr_registro_plano }} -
              {{ dadosPrincipais?.nm_plano }}
            </td>
          </tr>

          <tr>
            <td><span>017-Sexo do beneficiário:</span> {{ dadosPrincipais?.nm_id_sexo }}</td>
            <td><span>018-Data nascimento:</span> {{ dadosPrincipais?.dt_nascimento | date: 'dd/MM/yyyy' }}</td>
            <td>
              <span>019-Município do beneficiário:</span> {{ dadosPrincipais?.cd_municipio }} -
              {{ dadosPrincipais?.municipio_beneficiario }}
            </td>
          </tr>
        </tbody>

        <tbody>
          <tr>
            <th colspan="3"><span>Vínculos da guia</span></th>
          </tr>

          <tr>
            <td>
              <span>026-Nr. guia de solicitação de internação:</span>
              {{ dadosPrincipais?.nr_guia_solicitacao_internacao }}
            </td>
            <td><span>083-Nr. guia principal SP/SADT ou odonto:</span> {{ dadosPrincipais?.nr_guia_principal }}</td>
            <td><span>082-Nr. contrato valor pré:</span> {{ dadosPrincipais?.nr_contrato_valor_pre }}</td>
          </tr>
          <tr>
            <td>
              <span>081-Registro ANS da OPS intermediária:</span> {{ dadosPrincipais?.nr_registro_ans_intermediaria }}
            </td>
            <td><span>Operadora intermediária:</span> {{ dadosPrincipais?.nm_operadora_intermediaria }}</td>
            <td>
              <span>120-Tipo de atendimento por OPS intermediária:</span>
              {{ dadosPrincipais?.nm_tp_atendimento_intermediaria }}
            </td>
          </tr>
        </tbody>
      </table>
    </p-tabpanel>

    <p-tabpanel [value]="1">
      <table class="w-full detalhe-content">
        <tbody>
          <tr>
            <td><span>039-Tipo de internação:</span> {{ dadosInternacao?.nm_tp_internacao }}</td>
            <td><span>040-Regime de internação:</span> {{ dadosInternacao?.id_regime_internacao }}</td>
            <td></td>
          </tr>
          <tr>
            <td><span>046-Tipo de faturamento:</span> {{ dadosInternacao?.tp_faturamento }}</td>
            <td>
              <span>030-Data de início do faturamento:</span>
              {{ dadosInternacao?.dt_inicio_faturamento | date: 'dd/MM/yyyy' }}
            </td>
            <td>
              <span>031-Data final de atendimento ou do faturamento:</span>
              {{ dadosInternacao?.dt_fim_periodo | date: 'dd/MM/yyyy' }}
            </td>
          </tr>
          <tr>
            <td><span>041-Diagnóstico principal:</span> {{ dadosInternacao?.cd_cid_principal }}</td>
            <td><span>047-Qtde. diárias acompanhante:</span> {{ dadosInternacao?.qt_diaria_acompanhante }}</td>
            <td><span>048-Qtde diárias de UTI:</span> {{ dadosInternacao?.qt_diaria_uti }}</td>
          </tr>
          <tr>
            <td><span>042-Diagnóstico secundário:</span> {{ dadosInternacao?.cd_cid2 }}</td>
            <td><span>062-Declaração de nascido vivo:</span> {{ dadosInternacao?.nr_declara_nascido }}</td>
            <td><span>063-Declaração de óbito:</span> {{ dadosInternacao?.nr_declara_obito }}</td>
          </tr>
          <tr>
            <td><span>043-Terceiro diagnóstico:</span> {{ dadosInternacao?.cd_cid3 }}</td>
            <td><span>Declaração de nascido vivo 2:</span> {{ dadosInternacao?.nr_declara_nascido2 }}</td>
            <td><span>Declaração de óbito 2:</span> {{ dadosInternacao?.nr_declara_obito2 }}</td>
          </tr>
          <tr>
            <td><span>044-Quarto diagnóstico:</span> {{ dadosInternacao?.cd_cid4 }}</td>
            <td><span>Declaração de nascido vivo 3:</span> {{ dadosInternacao?.nr_declara_nascido3 }}</td>
            <td></td>
          </tr>
        </tbody>
      </table>
    </p-tabpanel>

    <p-tabpanel [value]="2">
      <table class="w-full detalhe-content">
        <tbody>
          <tr>
            <td><span>009-Tipo de registro:</span> {{ valoresProcessamento?.nm_tp_registro }}</td>
            <td><span>Situação registro:</span> {{ valoresProcessamento?.nm_id_situacao_registro }}</td>
            <td><span>Guias ANS:</span> {{ valoresProcessamento?.nm_st_guia_ans }}</td>
          </tr>
          <tr>
            <td>
              <span>032-Data do protocolo da cobrança:</span>
              {{ valoresProcessamento?.dt_protocolo_cobranca | date: 'dd/MM/yyyy' }}
            </td>
            <td><span>Nr. seq. guia:</span> {{ valoresProcessamento?.nr_seq_guia }}</td>
            <td><span>Nr. seq. incorpora:</span> {{ valoresProcessamento?.nr_seq_incorpora }}</td>
          </tr>
          <tr>
            <td>
              <span>080-Data do processamento da guia:</span>
              {{ valoresProcessamento?.dt_processamento | date: 'dd/MM/yyyy' }}
            </td>
            <td>
              <span>051-Valor processado da guia:</span> {{ valoresProcessamento?.vl_processado | number: '1.2-2' }}
            </td>
            <td>
              <span>050-Valor informado da guia:</span> {{ valoresProcessamento?.vl_guia_informado | number: '1.2-2' }}
            </td>
          </tr>
          <tr>
            <td><span>033-Data do pagamento:</span> {{ valoresProcessamento?.dt_pagto | date: 'dd/MM/yyyy' }}</td>
            <td><span>058-Valor total glosa:</span> {{ valoresProcessamento?.vl_glosa | number: '1.2-2' }}</td>
            <td><span>059-Valor total pago:</span> {{ valoresProcessamento?.vl_pago | number: '1.2-2' }}</td>
          </tr>
          @if (valoresProcessamento?.nr_seq_guia === 1) {
            <tr>
              <td></td>
              <td>
                <span>Valor pago acumulado da guia:</span>
                {{ valoresProcessamento?.vl_pago_acumulado_guia | number: '1.2-2' }}
              </td>
              <td>
                <span>Valor última glosa da guia:</span>
                {{ valoresProcessamento?.vl_ultima_glosa_guia | number: '1.2-2' }}
              </td>
            </tr>
          }
        </tbody>

        <tbody>
          <tr>
            <th colspan="3"><span>Distribuição dos valores pagos</span></th>
          </tr>

          <tr>
            <td>
              <span>052-Valor total pago procedimentos:</span>
              {{ valoresProcessamento?.vl_pago_procedimento | number: '1.2-2' }}
            </td>
            <td>
              <span>053-Valor total pago diárias:</span> {{ valoresProcessamento?.vl_pago_diaria | number: '1.2-2' }}
            </td>
            <td>
              <span>054-Valor total pago taxas e aluguéis:</span>
              {{ valoresProcessamento?.vl_pago_taxa | number: '1.2-2' }}
            </td>
          </tr>
          <tr>
            <td>
              <span>055-Valor total pago materiais:</span>
              {{ valoresProcessamento?.vl_pago_material | number: '1.2-2' }}
            </td>
            <td>
              <span>057-Valor total pago medicamentos:</span>
              {{ valoresProcessamento?.vl_pago_medicamento | number: '1.2-2' }}
            </td>
            <td><span>056-Valor total pago OPME:</span> {{ valoresProcessamento?.vl_pago_opme | number: '1.2-2' }}</td>
          </tr>
          <tr>
            <td>
              <span>084-Valor coparticipação:</span> {{ valoresProcessamento?.vl_copartic_guia | number: '1.2-2' }}
            </td>
            <td>
              <span>061-Valor total pago em tabela própria:</span>
              {{ valoresProcessamento?.vl_pago_tabela_propria | number: '1.2-2' }}
            </td>
            <td>
              <span>060-Valor total pago aos fornecedores</span>
              {{ valoresProcessamento?.vl_pago_fornecedor | number: '1.2-2' }}
            </td>
          </tr>
        </tbody>
      </table>

      <div class="flex valores-grids">
        <div class="col-6">
          <table class="w-full detalhe-content">
            <tr>
              <th><span>Modelos de remuneração</span></th>
            </tr>
          </table>

          <ag-grid-angular
            #agGridModeloRemuneracao
            class="ag-theme-balham w-full"
            style="height: 200px"
            [rowData]="valoresProcessamento?.row_modelo_remuneracao"
            [gridOptions]="gridOptionsModeloRemuneracao"
            >
          </ag-grid-angular>
        </div>
        <div class="col-6">
          <table class="w-full detalhe-content">
            <tr>
              <th><span>Lançamentos da guia</span></th>
            </tr>
          </table>
          <ag-grid-angular
            #agGridLancamentosGuia
            class="ag-theme-balham w-full"
            style="height: 200px"
            [rowData]="valoresProcessamento?.lanctos_guia"
            [gridOptions]="gridOptionsLancamentosGuia"
            >
          </ag-grid-angular>
        </div>
      </div>
    </p-tabpanel>

    <p-tabpanel [value]="3">
      <ag-grid-angular
        #agGridItensGuias
        class="ag-theme-balham w-full"
        [style.height]="innerHeight"
        [rowData]="itensGuias"
        [gridOptions]="gridOptionsItensGuias"
        >
      </ag-grid-angular>
    </p-tabpanel>

    <p-tabpanel [value]="4">
      <p-tabs [value]="0">
        <p-tablist>
          <p-tab [value]="0">Críticas Gestor IDSS</p-tab>
          <p-tab [value]="1">Motivos de rejeição ANS</p-tab>
        </p-tablist>
        <p-tabpanels>
        <p-tabpanel [value]="0">
          <ag-grid-angular
            #agGridCriticasGuia
            class="ag-theme-balham w-full"
            style="height: 500px"
            [rowData]="criticasGuia"
            [gridOptions]="gridOptionsCriticasGuia"
            >
          </ag-grid-angular>
        </p-tabpanel>
        <p-tabpanel [value]="1">
          <ag-grid-angular
            #agGridMotivosRejeicao
            class="ag-theme-balham w-full"
            style="height: 500px"
            [rowData]="motivosRejeicao"
            [gridOptions]="gridOptionsMotivosRejeicao"
            >
          </ag-grid-angular>
        </p-tabpanel>
        </p-tabpanels>
      </p-tabs>
    </p-tabpanel>

    <p-tabpanel [value]="5">
      <ag-grid-angular
        #agGridMovimentacaoGuia
        class="ag-theme-balham w-full"
        [style.height]="innerHeight"
        [rowData]="rowMovimentacaoGuiaTransformada"
        [columnDefs]="colDefsMovimentacaoTransformada"
        [tooltipShowDelay]="1000"
        [tooltipHideDelay]="3000"
        >
      </ag-grid-angular>
    </p-tabpanel>
    </p-tabpanels>
  </p-tabs>
</div>

<p-dialog
  [(visible)]="dialogBeneficiarioDisplay"
  [style]="{ width: '80vw', height: '80vh' }"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  [maximizable]="true"
  appendTo="body"
  >
  <ng-template pTemplate="header">
    <div class="flex align-items-center w-full">
      <h5 class="m-0">Dados do beneficiário no SIB</h5>
      <div class="flex align-items-center ml-auto">
        <bl-pesquisar-input class="mr-5" (onSearch)="onDialogBeneficiarioSearch($event)"></bl-pesquisar-input>
        @if (pseudonimizarActionVisible) {
          <button
            class="p-button p-button-outlined p-button-icon-only mr-2"
            (click)="togglePseudonimizar()"
            [title]="(pseudonimizarAction ? 'Desativar' : 'Ativar') + ' Pseudonimização'"
            >
            <i class="pi" [ngClass]="pseudonimizarAction ? 'pi-eye-slash' : 'pi-eye'"></i>
          </button>
        }
        <button
          class="p-button p-button-outlined p-button-icon-only mr-5"
          (click)="dialogBeneficiarioExportExcel()"
          pTooltip="Exportar Listagem como XLSX"
          tooltipPosition="bottom"
          >
          <i class="pi pi-file-excel"></i>
        </button>
      </div>
    </div>
  </ng-template>

  <div>
    <ag-grid-angular
      id="ag-grid-dialog"
      #agGridDialogBeneficiario
      class="ag-theme-balham w-full"
      [style.height]="'70vh'"
      [rowData]="dialogBeneficiarioData"
      [gridOptions]="gridOptionsDialogBeneficiario"
      >
    </ag-grid-angular>
  </div>
</p-dialog>

<p-dialog
  [(visible)]="dialogPrestadorDisplay"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  [maximizable]="true"
  [style]="{ width: '90vw', height: '90vh' }"
  header="Dados do prestador executante"
  >
  <bl-detalhe-prestador
    [nrCnpjCpfExec]="detalhePrestadorCnpjCpf"
    [cdGuiaMonitor]="detalhePrestadorCodigo"
    [nrCnesExec]="detalhePrestadorCnes"
    [nrRegistroPlano]="detalhePrestadorRegistroPlano"
  ></bl-detalhe-prestador>
</p-dialog>
